/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, effect, ElementRef, inject, Input, viewChild } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { ResourceTable } from "../../../service/resource-table.service";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { Observable, combineLatest, filter, first, map } from "rxjs";
import { ButtonComponent, SpinnerComponent } from "typedb-cloud-framework";
import { RightSidebarComponent } from "../sidebar/right/right-sidebar.component";
import { ApplicationState } from "../../../service/application-state.service";
import { AsyncPipe, NgClass } from "@angular/common";
import { trigger, style, state } from '@angular/animations';
import { NotificationService } from "../../../service/notification.service";
import { RouterLink } from "@angular/router";

export type ResourceAvailability = "ready" | "loading" | "failed";

export function resourceAvailabilityStreamOf(...resourceTables: ResourceTable<any, any>[]): Observable<ResourceAvailability> {
    return combineLatest(resourceTables.map(x => x.ready$)).pipe(
        map(loadingStates => loadingStates.some(y => !y) ? "loading" : "ready")
    );
}

@Component({
    selector: "tp-page-scaffold",
    templateUrl: "./page-scaffold.component.html",
    styleUrls: ["./page-scaffold.component.scss"],
    imports: [
        SidebarComponent, RightSidebarComponent, SpinnerComponent, NgClass, MatSidenavModule, ButtonComponent, AsyncPipe, RouterLink
    ],
    animations: [
        trigger("sidebarLeftMargin", [
            state("open", style({ "margin-left": "289px" })),
            state("collapsed", style({ "margin-left": "101px" })),
        ])
    ]
})
export class PageScaffoldComponent {
    @Input() pageAvailability: ResourceAvailability | null = "ready";
    novuInbox = viewChild<ElementRef<HTMLElement>>('novuInbox');
    notifications = inject(NotificationService);
    app = inject(ApplicationState);

    displayMFAEncouragementBanner$ = combineLatest([
        this.app.currentUser$, this.app.currentTeam$
    ]).pipe(
        filter(([user, team]) => !!user && !!team),
        map(([user, team]) => team!.mfaPolicy === "encouraged" && user!.mfaEnabled === false),
    );

    constructor() {
        effect(() => {
            const inbox = this.novuInbox()!;
            this.app.userAuth$.pipe(
                first(userAuth => !!userAuth.user?.uuid && !!userAuth.notificationSubscriberHash),
            ).subscribe(userAuth => {
                this.notifications.setup(userAuth.user!.uuid!, userAuth.notificationSubscriberHash!, inbox);
            });
        })
    }


    leftSidebarCollapsed = this.app.getSidebarCollapsed();
}
